import { api } from './http'
import type { PortalPushSubscriptionCommand, PortalPushConfiguration } from './portalMessaging'

export interface PortalPushDevice {
  id: string
  name: string
  current: boolean
  createdAt: string
  lastSuccessAt?: string | null
  lastFailureAt?: string | null
}
export interface PortalPushOptions {
  timezone: string
  showPreview: boolean
  quietStart: number | null
  quietEnd: number | null
  lessonChanges: boolean
  learningUpdates: boolean
}
let notificationBase = '/portal/notifications'
export function setNotificationContext(admin: boolean): void {
  notificationBase = admin ? '/portal-admin/notifications' : '/portal/notifications'
}
export const portalPushApi = {
  configuration: () => api.get<PortalPushConfiguration & { accountId?: string }>(`${notificationBase}/configuration`),
  devices: () => api.get<PortalPushDevice[]>(`${notificationBase}/devices`),
  register: (subscription: PortalPushSubscriptionCommand, name?: string, refreshOnly = false) =>
    api.post<PortalPushDevice[]>(`${notificationBase}/devices`, { subscription, name, refreshOnly }),
  remove: (id: string) => api.delete<void>(`${notificationBase}/devices/${id}`),
  test: (id: string) => api.post<{ acceptedDevices: number }>(`${notificationBase}/devices/${id}/test`),
  options: () => api.get<PortalPushOptions>(`${notificationBase}/options`),
  saveOptions: (options: PortalPushOptions) => api.put<PortalPushOptions>(`${notificationBase}/options`, options),
  chatPreference: (id: string) => api.get<{ muted: boolean }>(`${notificationBase}/chats/${id}`),
  saveChatPreference: (id: string, muted: boolean) => api.put<{ muted: boolean }>(`${notificationBase}/chats/${id}`, { muted }),
}
